<template>
    <div>
      <b-container>
        <b-row>
          <b-col sm="3">
            <SearchFilter/>
          </b-col>
          <b-col sm="9">
            <b-row>
              <b-col sm="4" v-for="(s, index) in 4" :key="index">
                <SingleTours :stars="2"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>
<script type="text/javascript">
import SearchFilter from './SearchFilter'
import SingleTours from '../global/SingleTours'
  export default {
    name:'SearchContent',
    components: {
      SearchFilter,
      SingleTours
    },
    data() {
      return {

      }
    }
  }
</script>
